export default function Badge({ status }) {
    const normalized = status.toUpperCase()

    const classes = {
        ACTIVE: 'bg-green-100 text-green-700',
        DELETED: 'bg-red-100 text-red-700',
        INACTIVE: 'bg-gray-100 text-gray-600',
        APPROVED: 'bg-green-100 text-green-700',
        SUCCESS: 'bg-green-100 text-green-700',
        FAILED: 'bg-red-100 text-red-700',
        REJECTED: 'bg-red-100 text-red-700',
        ACCEPTED: 'bg-green-100 text-green-700',
        PENDING: 'bg-yellow-100 text-yellow-700',
        IN_PROGRESS: 'bg-blue-200 text-blue-600',
        OTC_QUOTE_SHARED: 'bg-purple-100 text-purple-600',
        COMPLETED: 'bg-green-200 text-green-800',
        WITHDRAWN: 'bg-red-200 text-red-800',
        PROCESSING: 'bg-orange-100 text-orange-800',
        EXPIRED: 'bg-gray-200 text-gray-800',
        COMPLETED: 'bg-green-200 text-green-800',
        CREATED: 'bg-blue-100 text-blue-800',
        CREDIT: 'bg-green-100 text-green-700',
        DEBIT: 'bg-red-100 text-red-700',
    }

    const colorClass = classes[normalized] ?? 'bg-gray-100 text-gray-600'

    return (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colorClass}`}>
            {normalized}
        </span>
    )
}
